import { useContext, useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { CashRegisterReceiptsDto } from "../../../../dtos/documents/CashRegisterReceipts/CashRegisterReceiptsDto";
import { FormProvider, Resolver, useForm } from "react-hook-form";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NewDocumentModalViewContext } from "../../../Shared/NewDocumentModalView";
import { DocumentModalViewHeader } from "../../../Shared/DocumentModalViewHeader";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFTextAreaInput } from "../../../Shared/NewForms/NFTextAreaInput";
import { NFormTable } from "../../../Shared/NewForms/NFormTable";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { CashRegisterReceiptsModel } from "../../../../models/Documents/CashRegisterReceipts/CashRegisterReceiptsModel";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import { NFLookupCustomer } from "../../../Shared/NewForms/NFLookupCustomer";
import { NFLookupWarehouse } from "../../../Shared/NewForms/NFLookupWarehouse";
import { NFLookupPriceType } from "../../../Shared/NewForms/NFLookupPriceType";
import { NFLookupCashierShift } from "../../../Shared/NewForms/NFLookupCashierShift";
import { NFLookupProduct } from "../../../Shared/NewForms/NFLookupProduct";
import { NFLookupUnit } from "../../../Shared/NewForms/NFLookupUnit";
import { NFLookupVatType } from "../../../Shared/NewForms/NFLookupVatType";
import { CashRegisterReceiptPaymentType } from "../../../../dtos/documents/CashRegisterReceipts/CreateCashRegisterReceiptsDto";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import handleFormSubmit, { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import CashRegisterReceiptsDetailSkeleton from "./CashRegisterReceiptsDetailSkeleton";
import { CashRegisterReceiptsDetailFooter } from "./CashRegisterReceiptsDetailFooter";
import DocumentDetailViewToolbar from "../../../Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewPostButton from "../../../Shared/DetailViews/DetailViewPostButton";
import DetailViewSaveButton from "../../../Shared/DetailViews/DetailViewSaveButton";
import DetailViewCancelButton from "../../../Shared/DetailViewCancelButton";
import DetailViewToolbarMoreActions from "../../../Shared/DetailViews/DetailViewToolbarMoreActions";

interface IProps {
  model: CashRegisterReceiptsDto | null;
  modelUpdatedEvent: (newModel: CashRegisterReceiptsDto) => void;
}

export const CashRegisterReceiptsDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Cash Register Receipts");

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<CashRegisterReceiptsModel>();

  const CashRegisterReceiptPayment = [
    {
      id: CashRegisterReceiptPaymentType.cash,
      name: "Cash"
    },
    {
      id: CashRegisterReceiptPaymentType.transfer,
      name: "Transfer"
    },
    {
      id: CashRegisterReceiptPaymentType.bank,
      name: "Bank"
    },
    {
      id: CashRegisterReceiptPaymentType.vouchers,
      name: "Vouchers"
    },
    {
      id: CashRegisterReceiptPaymentType.giftCards,
      name: "Gift Cards"
    },
    {
      id: CashRegisterReceiptPaymentType.Other,
      name: "Other"
    }
  ];
  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;
  const watchProducts = watch("products");

  useEffect(() => {
    console.log(model);
    register("products");
    if (model) {
      setValue("id", model.id);
      setValue("documentNumber", model.documentNumber);
      setValue("documentDate", model.documentDate);
      setValue("customerId", model.customerId);
      setValue("warehouseId", model.warehouseId);
      setValue("priceTypeId", model.priceTypeId);
      setValue("cashRegisterRetailId", model.cashRegisterRetailId);
      setValue("createdDate", model.createdDate);
      setValue("cashierShiftId", model.cashierShiftId);
      setValue("products", model.products);
      setValue("payments", model.payments);
    }
  }, [model]);

  useEffect(() => {
    console.log(watchProducts);
  }, [watchProducts]);

  const handlePriceChanged = (newPrice: number, index: number) => {
    const newProducts = [...watchProducts];
    console.log("newProducts", newProducts);
    // @ts-ignore
    const newAmount = newPrice * newProducts[index].quantity;
    setValue(`products.${index}.amount`, newAmount);
    console.log(newAmount);
  };

  const handleQuantityChanged = (newQuantity: number, index: number) => {
    const newProducts = [...watchProducts];
    console.log("newProducts", newProducts);
    // @ts-ignore
    const newAmount = newQuantity * newProducts[index].price;
    setValue(`products.${index}.amount`, newAmount);
    console.log(newAmount);
  };

  const handleFormSubmitLocal = async (action: DocumentSaveActionType, data: CashRegisterReceiptsModel) => {
    await handleFormSubmit(action, data, model, saveHandler, postHandler);
  };

  if (!model) {
    return (
      <>
        <CashRegisterReceiptsDetailSkeleton />
      </>
    );
  }
  const handleTabChange = (index: number) => {
    setTabIndex(index);
  };

  const handleUploadFile = () => {};
  const exportToExcel = () => {};

  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        <NFTab title={"Products"} />
        <NFTab title={"Payments"} />
        <NFTab title={"Additional"} />
      </NFTabs>

      <div className={"modal-container-height"}>
        {/* <DocumentModalViewHeader
          onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))}
          onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))}
          onClose={closeHandler}
          onCancel={cancelHandler}
          handleUploadFile={handleUploadFile}
          exportToExcel={exportToExcel}
          fileName={fileName}
          setFileName={setFileName}
        /> */}
        <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))} />
          <DetailViewSaveButton onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))} />
          <DetailViewCancelButton onCancel={cancelHandler} />
          <DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel} fileName={fileName} setFileName={setFileName} />
        </DocumentDetailViewToolbar>

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <Row>
            <Col sm={6}>
              <NFTextInput title={"Document #"} fieldName={"documentNumber"} disabled />
            </Col>
            <Col sm={6}>
              <NFDateInput title={"Document Date"} fieldName={"documentDate"} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFLookupCustomer title="customerId" fieldName="customerId" />
            </Col>
            <Col sm={6}>
              <NFLookupCashierShift title="cashierShiftId" fieldName="cashierShiftId" />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFLookupPriceType title="priceTypeId" fieldName="priceTypeId" />
            </Col>
            <Col sm={6}>
              <NFLookupWarehouse title="Warehouse" fieldName="warehouseId" />
            </Col>
          </Row>
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <div className={"panel-body tabs-menu-body main-content-body-right"}>
            <NFormTable fieldArray={"products"}>
              <NFLookupProduct fieldName={"productId"} title={"productId"} width={200} />
              <NFLookupUnit fieldName={"unitId"} title={"Unit"} width={200} />
              <NFIntInput fieldName={"quantity"} title={"Quantity"} width={100} onValueChanged={handleQuantityChanged} />
              <NFIntInput fieldName={"price"} title={"Price"} width={100} onValueChanged={handlePriceChanged} />
              <NFIntInput title="Discount" fieldName="discount" />
              <NFIntInput fieldName={"amount"} title={"Amount"} width={100} />
              <NFLookupVatType title="vatRateId" fieldName="vatRateId" width={200} />
              <NFIntInput title="vatAmount" fieldName="vatAmount" />
              <NFIntInput title="amountWithVat" fieldName="amountWithVat" />
              {/*  */}
            </NFormTable>
          </div>
        </NFTabContainer>

        <NFTabContainer index={2} currentIndex={tabIndex}>
          <div className={"panel-body tabs-menu-body main-content-body-right"}>
            <NFormTable fieldArray={"payments"}>
              <NFLookupInput title={"Payment Type"} fieldName={"paymentType"} items={CashRegisterReceiptPayment} width={600} />
              <NFIntInput title="paymentAmount" fieldName="paymentAmount" width={100} />
            </NFormTable>
          </div>
        </NFTabContainer>

        <NFTabContainer index={3} currentIndex={tabIndex}>
          <div className={"panel-body tabs-menu-body main-content-body-right"}>
            <Row>
              <Col sm={12}>
                <NFTextAreaInput fieldName={"comment"} title={"Comment"} required={false} />
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <NFTextInput title={"Created User"} fieldName={"createdUser"} disabled={true} />
              </Col>
              <Col sm={6}>
                <NFDateInput title={"Created Date"} fieldName={"createdDate"} disabled={true} />
              </Col>
            </Row>
          </div>
        </NFTabContainer>
      </div>
      <CashRegisterReceiptsDetailFooter />
    </FormProvider>
  );
};
